<template>
  <v-app>
    <div id="app">
      <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.3.1/css/all.css" integrity="sha384-9ralMzdK1QYsk4yBY680hmsb4/hJ98xK3w0TIaJ3ll4POWpWUYaA2bRjGGujGT8w" crossorigin="anonymous">

      <h1 class="bb-heading text-center">
        {{ title }}
      </h1>

      <div class="container">
        <div class="alert alert-warning" v-if="show_local_alert && customband.template !== 'free'">
          <p><i class="fa fa-warning"></i> {{ show_local_alert }}</p>
        </div>

        <div class="alert alert-warning" v-for="msg in product_messages">
          <p>{{ msg.message }}</p>
        </div>

        <div class="tyvek-modal alert alert-danger" v-if="customband.template === 'free'">
          <p><i class="fa fa-warning"></i> Our Tyvek builder only works on a desktop computer.</p>
        </div>

      </div>

      <div class="bg-white sticky-top">
        <div class="container">
          <div class="band-preview">

            <div id="fpd">
              <!--<img ng-src="{{transparent_img}}" alt=" " class="transparent">-->
              <div class="fpd-product">

                <div class="row justify-content-center">
                  <!--<div class="col-12 col" ng-if="customBand.template === 'free'">-->
                  <!--<h6 class="text-center">Authentic Dupont&trade; Tyvek&reg; &bull; Durable and waterproof &bull; No minimum purchase &bull; Professional-quality, HD designs &bull; No setup charges</h6>-->
                  <!--</div>-->

                  <!--<div class="col-sm-4 col-6 text-right" ng-if="customband.template == 'fixed'">-->
                  <!--<a href="#" ng-click="share()"><img class="fb_share" ng-src="{{ share_fb_img }}" alt="Share your custom silicone wristband on Facebook"/></a>-->

                  <!--</div>-->
                </div>

                <band-preview v-if="customband.template === 'fixed'" stage='stage'></band-preview>
                <!--<free-image ng-if="customBand.template === 'free'" stage='stage' overlay="overlay"></free-image>-->
                <!--<div class="text-center" ng-if="customBand.template === 'free'">-->
                <!--<img ng-src="{{tyvek_description_img}}" alt="Tyvek description">-->
                <!--</div>-->
                <!--<toggle-overlay ng-if="customBand.template === 'free'"></toggle-overlay>-->
                <!--<free-image-controlls ng-if="customBand.template === 'free'"></free-image-controlls>-->
              </div>
            </div>
          </div>

          <v-dialog
                  v-model="$root.$data.fixedPreview.addingToCart"
                  persistent
                  width="300"
          >
            <v-card
                    color="primary"
                    dark
            >
              <v-card-text>
                Adding to cart...
                <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

        </div>
      </div>

      <div class="container">

        <p class="disclaimer d-none d-md-block text-center">
          <small><span v-if="customband.template !== 'free'">* Image above is not an exact representation.  Colors and Font Sizes may vary. We recommend using Chrome browser.&nbsp;Your text will be the band color unless you choose print color.</span></small>
        </p>
        <p class="disclaimer d-block d-md-none text-center">Sample only. We optimize before producing.</p>
      </div>

      <div class="lk-wrapper-bandbuilder" v-if="!customband.isTyvek() || (customband.isTyvek() && !isMobile)">
        <div class="container">
          <div class="row rowspace print-style-header">
            <div class="col text-right" v-if="!customband.isTyvek()">
              <h6 class="print-style">{{ customband.getPrintStyle().print_style.name }}</h6>
            </div>
            <div :class="{'col main-pricing': !customband.isTyvek(), 'text-center': customband.isTyvek()}">
              <pricing class="mr-2" :cssClass="'mainPricingBtn'" :tiers="customband.getPrintStyleProductPricingTiers()" type="product" title-text="Pricing" btn-text="Pricing" placement="bottom" style="display: inline;"/>
                <a class="btn btn-white d-none d-sm-inline mr-2" target="_blank" href="/speedy-delivery/"><img src="./assets/img/etatruck.png" alt="Check Shipping ETAs"></a>
            </div>
          </div>

          <section class="lk-wrapper-page">
            <div class="row d-none d-md-block side-nav-md">
              <div class="col-12 col">
                <div class="bb-progress">
                  <div class="bb-progress-top">
                    <nav-top prefix="top-" :states="customband.layout.manifest.states"></nav-top>
                  </div>
                </div>
              </div>
            </div>

            <div class="row content-row">
              <!-- Content -->
              <div class="col-12 col">
                <div class="alert alert-danger" role="alert" v-if="!alerts.empty() && isStateDirty()">
                  {{ alerts.get().text }}
                </div>
                <div v-for="warning in warnings.alerts" class="bandbuilder-messages alert alert-warning" v-bind:class="{'is-visible': warning}" role="alert">
                  {{ warning.text }}
                </div>
                <div class="bandbuilder-wrapper">
                  <router-view></router-view>
                </div>
              </div>
            </div>

          </section>
        </div>
      </div>

      <div class="app-bar">
        <div class="bb-progress">
          <div class="bb-progress-top d-none d-lg-block">
            <nav-top prefix="bottom-mobile-" :states="customband.layout.manifest.states"></nav-top>
          </div>
          <div class="bb-progress-bottom2 fixed-bottom d-lg-none">
            <nav-mobile></nav-mobile>
          </div>
        </div>
      </div>
    </div>
  </v-app>

</template>

<style lang="scss">
  @import "assets/css/shepherd-theme-dark.css";

  .app-bar {
    display: none;
    @media (max-width: 719px) {
      display: block;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 99;
      .bb-progress {
        margin: 0;
        border-top: 1px solid #dee2e6;
      }
    }
  }

</style>

<script>
  import axios from 'axios'
  import '@/builder/vuetify'
  import { mapState } from 'vuex'
  import _get from 'lodash/get'
  import bowser from 'bowser'
  import router from './router'

  export default {
    name: 'app',
    data () {
      return {
        show_local_alert: window.RB.show_local_alert,
        product_messages: window.RB.product_messages,
        require_fast_load: window.RB.require_fast_load,
      }
    },
    computed: {
      isMobile () {
        return bowser.mobile
      },
      title () {
        let title = 'Build Your Custom Wristbands'
        if (this.customband.product.name) {
          title = `Build Your Custom ${this.customband.product.name}`
        }
        return title
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates',
        'alerts',
        'warnings'
      ])
    },
    methods: {
      isStateDirty () {
        let currentRouteName = router.currentRoute.name
        let isDirty = _get(this.customstates.isDirty, currentRouteName)
        if (isDirty) {
          return true
        } else {
          return false
        }
      },
    },
    created () {
      // console.log('store.state.customband', store.state.customband)
      // console.log('this.$root.$data', this.$root.$data)

      let currentRouteName = router.currentRoute.name
      let allStates = _get(this.$store, 'state.customband.layout.manifest.states', null)
      let currentRouteExists = allStates.find((ele) => {
        return currentRouteName === ele.state
      })

      // Go to first state from manifest if the route requested doesn't exist in the manifest
      let firstState = _get(this.$store, 'state.customband.layout.manifest.states.0.state', null)
      if (firstState && !currentRouteExists) {
        router.replace({ name: firstState })
      }
    },
    mounted () {

      // Make the header not fixed to make room for the fixed preview
      let body = document.getElementsByClassName('navbar')[0]
      if (body) {
        body.classList.remove('fixed-top')
      }

      // <editor-fold desc="Populate CustomBand with Existing Data">
      // This is where we populate the Band Builder with existing data
      //      ex: When editing a phrase all their data is loaded into the Band Builder
      let totalFormsEl = document.getElementById('id_form-TOTAL_FORMS')
      let firstVariantEl = document.getElementById('id_form-0-product_variant')
      if (totalFormsEl && firstVariantEl) {
        let totalForms = parseInt(totalFormsEl.value, 10)
        let firstVariant = firstVariantEl.value
        if (totalForms && firstVariant) {
          this.$store.commit('customband/clearRows')

          let parsedData = null

          for (let i = 0; i < totalForms; i++) {
            let variantEl = document.getElementById('id_form-' + i + '-product_variant')
            let quantityEl = document.getElementById('id_form-' + i + '-quantity')
            let dataEl = document.getElementById('id_form-' + i + '-data')

            if (!variantEl || !quantityEl || !dataEl) {
              continue
            }

            let variant = variantEl.value
            let quantity = quantityEl.value
            let data = dataEl.value

            if (data) {
              parsedData = JSON.parse(data)

              // Each 'areas' in this loop could be different, so lets populate it so the methods below work correctly
              this.$store.commit('customband/populateAreas', parsedData)

              // If they're editing then it's like they've already selected a first color
              this.$store.commit('customband/setIsFirstPrintColorSelected', true)

              this.$store.commit('customband/setNotes', parsedData.notes)

              let pos
              for (let j = 0; j < this.customband.product.variants.length; j++) {
                if (this.customband.product.variants[j].id === parseInt(variant)) {
                  pos = j
                  break
                }
              }

              // Set the global print color
              //  Note: If the number of colors in the areas are 0 or more than 1 then the color fill value will be none
              //
              //        if numberOfColors === 0 then it's all debossed
              //        if numberOfColors === 1 then just use the color in the areas
              //        if numberOfColors > 1 then it's mixed colors so the row's color fill won't be used (aka null)
              let rowPrintColor = {_path: `customization.rows.${i}.colorFill`}
              let allPrintColors = this.customband.listOfPrintColors()
              let numberOfPrintColors = allPrintColors.length
              if (numberOfPrintColors === 1) {
                // Remove reactivity from the object so we can add the _path without
                //  Vuex yelling at us
                let firstColor = JSON.parse(JSON.stringify(allPrintColors[0]))

                // Make sure rowPrintColor is last so we keep the correct "_path" property
                rowPrintColor = Object.assign(firstColor, rowPrintColor)
              }

              // console.log('rowPrintColor', rowPrintColor)
              // console.log('parsedData.color1', parsedData.color1)
              // console.log('parsedData.color2', parsedData.color2)
              // console.log('parsedData.color3', parsedData.color3)

              let color1 = _get(parsedData, 'color1')
              let color2 = _get(parsedData, 'color2')
              let color3 = _get(parsedData, 'color3')

              let color1Path = _get(color1, '_path')
              if (!color1Path) {
                color1._path = `customization.rows.${i}.color1`
              }
              let color2Path = _get(color2, '_path')
              if (color2) {
                if (!color2Path) {
                  color2._path = `customization.rows.${i}.color2`
                }
              }
              let color3Path = _get(color3, '_path')
              if (color3) {
                if (!color3Path) {
                  color3._path = `customization.rows.${i}.color3`
                }
              }

              let newRow = {
                'color1': parsedData.color1,
                'color2': parsedData.color2,
                'color3': parsedData.color3,
                'colorFill': rowPrintColor,
                'bandType': this.customband.product.name,
                'qty': parseInt(quantity),
                'variant': this.customband.product.variants[pos]
              }

              // console.log('newRow', newRow)

              this.$store.commit('customband/addRow', newRow)
            }
          }
          this.$store.commit('customband/selectRow', 0)

          // Render the preview now that BandPreview data is loaded.
          // The initial render was deferred to avoid showing the default
          // color before the correct BandPreview data was available.
          // Use $nextTick to ensure Vuex state is fully updated first.
          this.$nextTick(() => {
            this.$root.$data.fixedPreview.render()
          })
        }
      }
      // </editor-fold>

      axios.get('/api/getfontcharacters/').then(resp => {
        //console.log('resp', resp)
        this.$store.commit('customband/setFontChars', resp.data.all_chars)
      })

    }
  }
</script>
